import { render, staticRenderFns } from "./WarnStatistics.vue?vue&type=template&id=77448752&scoped=true"
import script from "./WarnStatistics.vue?vue&type=script&lang=js"
export * from "./WarnStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77448752",
  null
  
)

export default component.exports